import React, { useState, useEffect } from "react";
import Card from "common/components/Card/Card.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import { Calendar, momentLocalizer } from "react-big-calendar";
import Month from "react-big-calendar/lib/Month";
import moment from "moment";
import Toolbar from "react-big-calendar/lib/Toolbar";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import loadContent from "core-module/hoc/loadContent";

import withStyles from "@material-ui/core/styles/withStyles";

const localizer = momentLocalizer(moment);

const styles = {
  monthSummary: {
    fontSize: "15px",
  },
  downstreamStyle: {
    color: "#1a3768",
  },
  upstreamStyle: {
    color: "#4caf50",
  },
  aggregateStyle: {
    color: "#dd3449",
  },
};

let newDate = new Date();

const DataCalendar = (props) => {
  const [events, setEvents] = useState([]);
  const [monthTotal, setMonthTotal] = useState({});
  const calendarData = props.getData("calendarData");
  const summaryData = props.getData("summary");

  const { classes } = props;

  const mySeparator = window.innerWidth < 650 ? <br /> : "  |  ";

  hideNext = true;
  hideBack = false;
  Month.title = (date, _ref4) => {
    newDate = moment(date).add(1, "M")._d;
    let localizer = _ref4.localizer;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} lg={12}>
            {localizer.format(date, "monthHeaderFormat")}
          </GridItem>
          <br />
          {date.getMonth() in monthTotal &&
          new Date().getTime() - date.getTime() < 1000 * 3600 * 24 * 31 * 3 ? (
            <GridItem xs={12} lg={12}>
              <div
                key={"monthsummary" + date.getMonth()}
                className={classes.monthSummary}
              >
                <span className={classes.downstreamStyle}>
                  Downstream:{" "}
                  {monthTotal[date.getMonth()].downstream.toFixed(3)}
                  <small> GB</small>
                </span>
                {mySeparator}
                <span className={classes.upstreamStyle}>
                  Upstream: {monthTotal[date.getMonth()].upstream.toFixed(3)}{" "}
                  <small> GB</small>
                </span>
                {mySeparator}
                <span className={classes.aggregateStyle}>
                  Aggregate: {monthTotal[date.getMonth()].aggregate.toFixed(3)}
                  <small> GB</small>
                </span>
              </div>
            </GridItem>
          ) : null}
        </GridContainer>
      </div>
    );
  };

  useEffect(() => {
    let newEvents = [];

    for (let d of calendarData) {
      newEvents.push({
        customType: "downstream",
        a: d.d,
        title: d.d + " GB",
        start: new Date(d.t[0], d.t[1] - 1, d.t[2]),
        end: new Date(d.t[0], d.t[1] - 1, d.t[2]),
      });
      newEvents.push({
        customType: "upstream",
        a: d.u,
        title: d.u + " GB",
        start: new Date(d.t[0], d.t[1] - 1, d.t[2]),
        end: new Date(d.t[0], d.t[1] - 1, d.t[2]),
      });
      newEvents.push({
        customType: "aggregate",
        a: d.a,
        title: d.a + " GB",
        start: new Date(d.t[0], d.t[1] - 1, d.t[2]),
        end: new Date(d.t[0], d.t[1] - 1, d.t[2]),
      });
    }
    setEvents(newEvents);
    setMonthTotal(summaryData);
  }, [calendarData, summaryData]);

  const selectEvent = (event) => {
    let date = event.start;
    date.setHours(0, 0, 0, 0);

    if (
      date.getTime() / 1000 <
      new Date().getTime() / 1000 - 3600 * 24 * 30 * 3
    ) {
      return null;
    }

    let graphicStart = date.getTime() / 1000;
    props.focusDate(graphicStart, event.customType);
    goToGraphTab();
  };

  const selectSlot = (slotInfo) => {
    let date = slotInfo.start;
    date.setHours(0, 0, 0, 0);

    if (
      date.getTime() / 1000 <
      new Date().getTime() / 1000 - 3600 * 24 * 30 * 3
    ) {
      return null;
    }

    let graphicStart = date.getTime() / 1000;
    props.focusDate(graphicStart, "all");
    goToGraphTab();
  };

  const eventColors = (event, start, end, isSelected) => {
    let cn;
    cn = "event-" + event.customType;
    return {
      className: cn,
    };
  };
  const goToGraphTab = () => {
    props.changesTabs("", 1);
  };

  return (
    <div>
      <Card>
        <CardBody calendar>
          <Calendar
            selectable
            localizer={localizer}
            events={events}
            defaultView="month"
            defaultDate={new Date()}
            components={{ toolbar: CustomToolbar }}
            views={{ month: Month }}
            eventPropGetter={eventColors}
            on
            SelectSlot={(slotInfo) => selectSlot(slotInfo)}
            onSelectEvent={(event) => selectEvent(event)}
          />
        </CardBody>
      </Card>
    </div>
  );
};

/*
<p>
  *For technical reasons, the calendar aggregate data may differ slightly
  from the dashboard data usage (which is the one that matters for monthly
  data usage metering){" "}
</p>
*/
export default withStyles(styles)(
  loadContent("user.session/broadbandcalendar", DataCalendar)
);

let hideNext = true;
let hideBack = false;
let currentMonth = new Date().getMonth();

const disabledBtnStyle = {
  backgroundColor: "rgba(39, 170, 225,0.4)",
};

class CustomToolbar extends Toolbar {
  handleNextButton = () => {
    hideBack = false;
    if (currentMonth === newDate.getMonth()) {
      hideNext = true;
    }
    this.navigate("NEXT");
  };

  handleBackButton = () => {
    hideNext = false;
    let test = new Date().getTime();

    if (newDate.getTime() - test < 3600 * 24 * 30 * 3) {
      hideBack = true;
    }
    this.navigate("PREV");
  };

  handleTodayButton = () => {
    hideNext = true;
    hideBack = false;
    this.navigate("TODAY");
  };

  disableNext = () => {
    return (
      <div className="rbc-toolbar">
        <GridContainer>
          <GridItem xs={12} l={12}>
            <span className="rbc-btn-group">
              <button type="button" onClick={() => this.handleBackButton()}>
                back
              </button>
              <button type="button" disabled style={disabledBtnStyle}>
                next
              </button>
            </span>
            <span className="rbc-toolbar-label">{this.props.label}</span>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  disableBack = () => {
    return (
      <div className="rbc-toolbar">
        <GridContainer>
          <GridItem xs={12} l={12}>
            <span className="rbc-btn-group">
              <button type="button" disabled style={disabledBtnStyle}>
                back
              </button>
              <button type="button" onClick={() => this.handleNextButton()}>
                next
              </button>
            </span>
            <span className="rbc-toolbar-label">{this.props.label}</span>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  returnFullToobar = () => {
    return (
      <div className="rbc-toolbar">
        <GridContainer>
          <GridItem xs={12} l={12}>
            <span className="rbc-btn-group">
              <button type="button" onClick={() => this.handleBackButton()}>
                back
              </button>
              <button type="button" onClick={() => this.handleNextButton()}>
                next
              </button>
            </span>
            <span className="rbc-toolbar-label">{this.props.label}</span>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  getToolbar = () => {
    if (hideNext === true) {
      return <div> {this.disableNext()}</div>;
    } else if (hideBack === true) {
      return <div> {this.disableBack()}</div>;
    } else {
      return <div>{this.returnFullToobar()}</div>;
    }
  };

  render() {
    return <div>{this.getToolbar()}</div>;
  }
}
